export default __webpack_public_path__ + "img/0999e39473cf8bcc0e5d8c1675fd0917.png";